// Novala — My accountant: shared constants (palette tokens, timings, storage keys)

export const PALETTE = {
  ink: '#0E1A1A',
  ink2: '#3A4A52',
  ink3: '#6B7684',
  ink4: '#96A0AB',
  line: '#D8DEE6',
  lineSoft: '#ECEFF3',
  page: '#F7F9FA',
  teal: '#0F6E56',
  tealDark: '#0A5544',
  tealBg: '#E6EFEC',
  amber: '#D97706',
  amberBg: '#FEF3E7',
  red: '#B91C1C',
  redBg: '#FEF2F2',
  redBorder: '#FECACA',
  redIcon: '#DC2626',
} as const;

/** How long a pending invite stays valid. */
export const INVITE_EXPIRY_DAYS = 30;

/** After an invite expires, how many extra days we keep the expired card visible
 *  before auto-archiving it into Previously connected. */
export const EXPIRED_ARCHIVE_AFTER_DAYS = 7;

export const TOAST_DURATION_MS = 3200;
export const ROLLING_DURATION_MS = 800;

/** localStorage key for the Previously connected list.
 *  The active record uses the hook's own key (novala.myAccountant.record). */
export const STORAGE_KEY_PREVIOUS = 'novala.myAccountant.previous';

/** Human-readable labels for the reason an accountant was archived. */
export const PREVIOUS_REASON_LABELS = {
  removed: 'Removed',
  expired: 'Invite expired',
  declined: 'Invite declined',
} as const;